import { FC, ReactElement } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import useAccount from 'src/hooks/useAccount'
import { generateLoginURL } from 'src/utils/urls'

interface Props {
  children: ReactElement
}

// Render `children` if the user is logged in, otherwise navigate to the
// login page. Replaces the v5 PrivateRoute wrapper.
const PrivateRouteGuard: FC<Props> = ({ children }) => {
  const { isLogged } = useAccount()
  const location = useLocation()

  if (!isLogged) return <Navigate to={generateLoginURL(location)} replace />

  return children
}

export default PrivateRouteGuard
